import Vue from "vue";
import router from "@/router";
// axios
import axios from "axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import authHelpers from "@/utils/auth-helpers";
import { BACK_BASE_URL } from "@/base-url";
const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: BACK_BASE_URL,
  // https://back.ngo-platform.com/api
  // timeout: 1000,
  headers: {
    accept: "application/json",
    lang: "ar",
    "access-control-allow-origin": "*",
    "Access-Control-Allow-Headers": "*",
    'ngrok-skip-browser-warning': 'true',
  },
  validateStatus: () => true,
});

// Add a request interceptor
axiosIns.interceptors.request.use(
  function (config) {
    var routeMeta = router.history.current.meta;
    if (
      routeMeta &&
      !routeMeta.whiteListed &&
      !routeMeta.temp &&
      !routeMeta.ministry &&
      !routeMeta.redirectIfLoggedIn
    )
      return {
        ...config,
        params: {
          ...config.params,
          _ni: localStorage.getItem("ni"),
          _token: localStorage.getItem("passToken"),
        },
      };
    else return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axiosIns.interceptors.response.use(function (response) {
  if ([401].includes(response.status)) {
    authHelpers.reset();
    if (!router.currentRoute.path.includes("auth")) {
      if (router.currentRoute.meta.ministry)
        router.push({ name: "ministry-login" });
      else router.push({ name: "auth-login" });
      Vue.$toast({
        component: ToastificationContent,
        props: {
          title: "عملية غير مصرحة",
          icon: "AlertCircleIcon",
          text: "ليس لديك التصريح لتنفيذ هذه العملية",
          variant: "danger",
        },
      });
    }
  } else if (response.status === 422) {
    const errorsArr = [];
    for (const key in response.data.errors) {
      if (Object.hasOwnProperty.call(response.data.errors, key)) {
        const element = response.data.errors[key];
        errorsArr.push(element.join(" \n  "));
      }
    }
    const errorsMessage = errorsArr.join(" \n ");
    Vue.$toast({
      component: ToastificationContent,
      props: {
        title: response.data.message,
        icon: "AlertCircleIcon",
        text: errorsMessage,
        variant: "danger",
        timeout: 10000,
      },
    });
    Vue.$toast({
      component: ToastificationContent,
      props: {
        title: "خطأ في البيانات المدخلة",
        icon: "AlertCircleIcon",
        text: errorsMessage,
        variant: "danger",
        timeout: 10000,
      },
    });
  } else if (response.status === 400) {
    const errorsArr = [];
    for (const key in response.data.errors) {
      if (Object.hasOwnProperty.call(response.data.errors, key)) {
        const element = response.data.errors[key];
        errorsArr.push(element.join(" \n  "));
      }
    }
    const errorsMessage = errorsArr.join(" \n ");
    Vue.$toast({
      component: ToastificationContent,
      props: {
        title: response.data.message,
        icon: "AlertCircleIcon",
        text: errorsMessage,
        variant: "danger",
        timeout: 10000,
      },
    });
  }  else if (response.status === 403) {
    Vue.$toast({
      component: ToastificationContent,
      props: {
        title: "عملية محجوبة",
        icon: "AlertCircleIcon",
        text: "ليس لديك الصلاحيات اللازمة لتنفيذ هذه العملية",
        variant: "danger",
      },
    });
  }
  return response;
});

Vue.prototype.$axios = axiosIns;
export default axiosIns;
